import React, {Component} from 'react';

import Header from '../decoration/header';
import OrderPageProgressBar from '../decoration/orderPageProgressBar';
import OrderListPanel from './orderListPanel';
import Footer from '../footer/footer';

import {connect} from "react-redux";
import {fetchUserToken} from "../../redux/actions";
import './orderPage3.css';

class OrderPage3 extends Component {
  componentDidMount(){
  }
  render() {
    return(
      <div className="OrderPage3">
        <Header />
        <OrderPageProgressBar index="3" />
        <OrderListPanel />
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state){
    return({
      ...state
    });
}

export default connect(mapStateToProps, {fetchUserToken})(OrderPage3);



// WEBPACK FOOTER //
// ./src/components/orderPage3/orderPage3.js